// GUIDED-FLOW: `/c/{slug}/flows/{id}`, a guided flow as a full-screen panel (where the
// invitation lands when the new member has an open flow, and where a chat card's Open goes).
import { createRoute, useNavigate } from "@tanstack/react-router";
import { FlowPage } from "../features/flows/flow-panel";
import { useCompany } from "../features/use-feature";
import { companyRoute } from "./c.$slug";

export const flowRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "flows/$id",
  component: function Flow() {
    const { api } = flowRoute.useRouteContext();
    const { id } = flowRoute.useParams();
    const company = useCompany();
    const navigate = useNavigate();
    return (
      <FlowPage
        key={id}
        api={api}
        company={company}
        runId={id}
        onClose={() => void navigate({ to: "/c/$slug", params: { slug: company.slug } })}
      />
    );
  },
});
